import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class StarRatingByChannel extends Component {
  render() {
    return (
      <BaseChart
        id="starRatingByChannel"
        type="bar"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={{
          doNotTranslateTooltipTitle: true,
          indexAxis: 'y',
          scales: {
            x: {
              ticks: {
                suggestedMin: this.props.data.chart_min,
              },
            },
          },
        }}
        labelParam="channel"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default StarRatingByChannel;
